// Utility per generare identificativi univoci con un prefisso opzionale
export const generateId = (prefix = 'id') => {
  const timestamp = Date.now();
  const randomPart = Math.floor(Math.random() * 1e9);
  return `${prefix}-${timestamp}-${randomPart}`;
};
